<template>
  <div class="row mb-3">
    <h3 class="fw-bold mb-6">Yeni istifadəçi əlavə et</h3>
    <div class="col-sm-12">
      <div class="card mb-3">
        <div class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
          <h6 class="mb-0 fw-bold ">Yeni istifadəçi yaratmaq</h6>
        </div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="addUser">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <label class="form-label">Partners</label>
                <select class="form-select" v-model="nitem.partnerId" name="specialityDropdown" required>
                  <option></option>
                  <option v-for="(partner, index) in partners" :key="index" :value="partner.name">{{ partner.name }}</option>
                </select>
                <span class="inputError">{{ errors.first('specialityDropdown') }}</span>
              </div>
              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">smsFee</label>
                <input type="text" v-model.number="nitem.smsFee"  name="smsFee" id="firstName" class="form-control" required>
                <span class="inputError">{{ errors.first('smsFee') }}</span>
              </div>

              <div class="col-md-6">
                <label for="firstName" class="form-label">smsBalance</label>
                <input type="text" v-model.number="nitem.smsBalance" name="smsBalance" id="firstName" class="form-control" required="">
                <span class="inputError">{{ errors.first('smsBalance') }}</span>
              </div>

              <!-- SMS Notification -->
              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox" class="form-label">Aktiv</label>
                  <input type="checkbox" v-model="nitem.isActive" class="smsCheckbox" name="smsCheckbox" id="smsCheckbox">
                </div>
              </div>

              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox2" class="form-label">requiredSmsShablonConfirmation</label>
                  <input type="checkbox" v-model="nitem.requiredSmsShablonConfirmation" name="smsCheckbox2" class="smsCheckbox" id="smsCheckbox2">
                </div>
              </div>
            </div>

            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Yaddaşa yaz
            </button>
          </form>
        </div>
      </div>
    </div>
    <br>
    <br>
    <div class="col-sm-12">
      <div class="card mb-3">
        <div class="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
          <h6 class="mb-0 fw-bold ">Yeni istifadəçi 0-dan yaratmaq</h6>
        </div>

        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="addUser2">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <label for="partnerId2" class="form-label">PartnerId</label>
                <input type="text" v-model="nitem2.partnerId" name="partnerId2" id="partnerId2" class="form-control" required="">
                <span class="inputError">{{ errors.first('partnerId2') }}</span>
              </div>
              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName2" class="form-label">smsFee</label>
                <input type="text" v-model.number="nitem2.smsFee" name="smsFee2" id="firstName2" class="form-control" required="">
                <span class="inputError">{{ errors.first('smsFee2') }}</span>
              </div>

              <div class="col-md-6">
                <label for="firstName" class="form-label">smsBalance</label>
                <input type="text" v-model.number="nitem2.smsBalance" name="smsBalance2" id="firstName" class="form-control" required="">
                <span class="inputError">{{ errors.first('smsBalance') }}</span>
              </div>

              <div class="col-md-6">
                <label for="listeningUrl" class="form-label">listeningUrl</label>
                <input type="text" v-model="nitem2.listeningUrl" name="listeningUrl2" id="listeningUrl" class="form-control" required>
              </div>

              <div class="col-md-6">
                <label for="sendingUrl" class="form-label">sendingUrl</label>
                <input type="text" v-model="nitem2.sendingUrl" name="sendingUrl2" id="sendingUrl" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels1" class="form-label">operatorChannels: Azercell</label>
                <input type="text" v-model="nitem2.operatorChannels[1]" name="operatorChannels1" id="operatorChannels1" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels2" class="form-label">operatorChannels: Bakcell</label>
                <input type="text" v-model="nitem2.operatorChannels[2]" name="operatorChannels2" id="operatorChannels2" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="operatorChannels3" class="form-label">operatorChannels: Nar</label>
                <input type="text" v-model="nitem2.operatorChannels[3]" name="operatorChannels3" id="operatorChannels3" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Azercell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[0].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Azercell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[0].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Bakcell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[1].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Bakcell</label>
                <input type="text" v-model="nitem2.shortNumberChannels[1].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.shortNumber" class="form-label">shortNumberChannels.shortNumber: Nar</label>
                <input type="text" v-model="nitem2.shortNumberChannels[2].shortNumber" name="shortNumberChannels.shortNumber" id="shortNumberChannels.shortNumber" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumberChannels.channel" class="form-label">shortNumberChannels.channel: Nar</label>
                <input type="text" v-model="nitem2.shortNumberChannels[2].channel" name="shortNumberChannels.channel" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Azercell</label>
                <input type="text" v-model="shortNumbers[1]" name="shortNumbers"  class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Bakcell</label>
                <input type="text" v-model="shortNumbers[2]" name="shortNumbers" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="shortNumbers" class="form-label">shortNumbers: Nar</label>
                <input type="text" v-model="shortNumbers[3]" name="shortNumbers" class="form-control">
              </div>

              <div class="col-md-6">
                <label for="clientIps" class="form-label">clientIps</label>
                <textarea type="text" v-model="clientIps" name="clientIps" class="form-control" rows="5"></textarea>
              </div>

              <!-- SMS Notification -->
              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox" class="form-label">Aktiv</label>
                  <input type="checkbox" v-model="nitem2.isActive" class="smsCheckbox" name="smsCheckbox" id="smsCheckbox">
                </div>
              </div>

              <div class="col-md-6 d-flex flex-row">
                <div class="d-flex flex-column">
                  <label for="smsCheckbox2" class="form-label">requiredSmsShablonConfirmation</label>
                  <input type="checkbox" v-model="nitem2.requiredSmsShablonConfirmation" name="smsCheckbox2" class="smsCheckbox" id="smsCheckbox2">
                </div>
              </div>
            </div>

            <!-- Submit button -->
            <button type="submit" class="btn btn-primary mt-4" :disabled="loading">
              Yaddaşa yaz
            </button>
          </form>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import user from '../../../store/user'
import jwtInterceptor from '../../../jwt.interceptor'
import store from '../../../store'

export default {
  name: 'UserCreate',
  data() {
    return {
      shortNumbers: {
          1: "",
          2: "",
          3: ""
        },
      clientIps: "",
      nitem: {
        partnerId: "",
        isActive: true,
        requiredSmsShablonConfirmation: true,
        smsFee: 0,
        smsBalance: 0
      },
      nitem2: {
        partnerId: "",
        smsBalance: 0,
        smsFee: 0,
        operatorChannels: {
          1: "",
          2: "",
          3: ""
        },
        shortNumberChannels: [
          {
            mobileOperator: 1,
            shortNumber: "",
            channel: ""

          },
          {
            mobileOperator: 2,
            shortNumber: "",
            channel: ""

          },
          {
            mobileOperator: 3,
            shortNumber: "",
            channel: ""

          }
        ],
        listeningUrl: "",
        clientIps: [],
        shortNumbers: {
          1: "",
          2: "",
          3: ""
        },
        sendingUrl: null,
        isActive: true,
        requiredSmsShablonConfirmation: true
      },
      roles: [],
      partners: [],
      loading: false,
    }
  },
  methods: {
    async addUser() {

      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.post(this.$store.getters.getUrl + "/Users/CreateFromExistingPartner", this.nitem).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("İstifadəçi uğurla əlavə olundu!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.back()
          }
          else {
            this.$toast.error("Bir xəta baş verdi. Bir daha sınayın!", {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch((e) => {
          this.$toast.error(e.data.responseException[0], {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
    },
    async addUser2() {

      this.nitem2.shortNumbers[1] =  this.shortNumbers[1].split(',')
      this.nitem2.shortNumbers[2] =  this.shortNumbers[2].split(',')
      this.nitem2.shortNumbers[3] =  this.shortNumbers[3].split(',')
      this.nitem2.clientIps =  this.clientIps.split(',').map(ip => ip.trim())
      const validForm = await this.isFormValid()
      if (validForm) {
        this.loading = true
        jwtInterceptor.post(this.$store.getters.getUrl + "/Users", this.nitem2).then(response => {
          if (response.data.isError === null) {
            this.$toast.success("İstifadəçi uğurla əlavə olundu!", {
              position: "top-right"
            })
            this.loading = false
            this.$router.back()
          }
          else {
            this.$toast.error(response.data.responseException, {
              position: "top-right"
            });
            this.loading = false
          }
        }).catch((e) => {
          this.$toast.error(e.data.responseException[0], {
            position: "top-right"
          });
          this.loading = false
        })
      } 
      else {
        this.$toast.error("Xanalar düzgün doldurulmayıb. Bir daha xanaları yoxlayın!", {
          position: "top-right"
        })
        this.loading = false
      }
    },
    getPartners() {
        jwtInterceptor.get(this.$store.getters.getUrl+'/GeneralPartners/GetNonPartnerUsers')
        .then( response => {
          this.partners = response.data.result;
        })
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  created() {
    this.roles = user.state.roles;
    this.getPartners();
  }
}
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}
</style>